var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"btn",on:{"click":function($event){$event.preventDefault();return _vm.$emit('handleClick')}}},[(_vm.iconClass)?_c('v-icon',{attrs:{"clsName":_vm.iconClass}}):_vm._e(),(!_vm.textHide)?[_vm._v(" "+_vm._s(_vm.text)+" ")]:[_c('span',{staticClass:"access_hidden"},[_vm._v(_vm._s(_vm.text))])]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }